import * as types from './types'
import storage from '@/plugins/storage'
export default {
  passthrough: '',
  token: storage.session.getItem(types.SESSION_TOKEN_NAME),
  roles: JSON.parse(storage.session.getItem(types.SESSION_ROLES_NAME)),
  userProfile: JSON.parse(storage.session.getItem(types.SESSION_USER_PROFILE)),
  primaryRole: JSON.parse(storage.session.getItem(types.SESSION_PRIMARY_ROLE)),
  phoneNumber: JSON.parse(storage.session.getItem(types.SESSION_PHONE_NUMBER)),
  phoneExtension: JSON.parse(storage.session.getItem(types.SESSION_PHONE_EXTENSION))
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/state.js